module.exports = __webpack_public_path__ + "img/sbrc.ca6bc507.png";